import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';

interface CookieBannerViewProps {
  title: string;
  description: string;
  acceptButtonText: string;
  declineButtonText: string;
  onAccept: () => void;
  onDecline: () => void;
}

const CookieBannerView = (props: CookieBannerViewProps) => {
  const { title, description, acceptButtonText, declineButtonText, onAccept, onDecline } = props;

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 99999,
        right: 8,
        bottom: 8,
        padding: 8,
        borderRadius: 8,
        maxWidth: {
          sm: 600,
        },
        width: 'calc(100% - 18px)',
        backgroundColor: 'grey.900',
        maxHeight: (theme) => `calc(100% - ${theme.spacing(16)})`,
        boxSizing: 'border-box',
        overflow: 'auto',
      }}
    >
      <Box mb={6}>
        <Typography variant='h4' component='h2' gutterBottom color='grey.100'>
          {title}
        </Typography>
        <Typography variant='body1' color='grey.300'>
          {description}
        </Typography>
      </Box>
      <Box>
        <Grid container spacing={6}>
          <Grid>
            <Button variant='contained' color='secondary' onClick={onAccept}>
              {acceptButtonText}
            </Button>
          </Grid>
          <Grid>
            <Button onClick={onDecline} sx={{ color: 'grey.100' }}>
              {declineButtonText}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default CookieBannerView;
